
import React from 'react';
import { Button } from "@/components/ui/button";
import { FileImage, File, Sparkles } from "lucide-react";

interface EditorToolbarProps {
  onImageUploadClick: () => void;
  onPdfUploadClick: () => void;
  onTextFormat: () => void;
  onAITextFormat: () => void;
  isUploading: boolean;
  isFormatting: boolean;
}

const EditorToolbar: React.FC<EditorToolbarProps> = ({ 
  onImageUploadClick,
  onPdfUploadClick,
  onTextFormat,
  onAITextFormat,
  isUploading,
  isFormatting
}) => {
  return (
    <div className="flex flex-wrap gap-2 mb-2">
      <Button 
        type="button" 
        variant="outline" 
        size="sm" 
        onClick={onImageUploadClick}
        disabled={isUploading || isFormatting}
      >
        <FileImage className="h-4 w-4 mr-1" />
        Afbeelding toevoegen
      </Button>
      
      <Button 
        type="button"
        variant="outline"
        size="sm"
        onClick={onPdfUploadClick}
        disabled={isUploading || isFormatting}
      >
        <File className="h-4 w-4 mr-1" />
        PDF toevoegen
      </Button>

      <div className="flex-grow flex justify-center">
        <Button 
          type="button"
          variant="secondary"
          size="sm"
          onClick={onAITextFormat}
          disabled={isFormatting}
        >
          <Sparkles className="h-4 w-4 mr-1" />
          {isFormatting ? "AI bezig..." : "AI tekstopmaak"}
        </Button>
      </div>
    </div>
  );
};

export default EditorToolbar;
